module.exports = __webpack_public_path__ + "static/media/img39.b3c5598b.jpg";